import React, { Component } from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import Popup from '../../Popup';
import { rescheduleTaskRequest } from '@core/api/task/task.service';
import { connect } from 'react-redux';

class RescheduleTaskPopup extends Component {
  constructor(props) {
    super(props);
    const selectedDetails = this.props.idTasks.reduce(
      (acc, id) => {
        const numericId = parseInt(id, 10);
        const task = this.props.tasks.find((item) => item.taskId === numericId);
        if (task) {
          acc.taskNum.push(`[${task.taskId}]`);
          acc.taskType.push(`[${task.taskType}]`);
        }
        return acc;
      },
      { taskNum: [], taskType: [] },
    );

    this.state = {
      taskDetails: {
        taskNum: selectedDetails.taskNum.join(' '),
        taskType: selectedDetails.taskType.join(' '),
      },
      dateSelected: new Date(),
      rescheduleSuccess: true,
      rescheduleFail: false,
      dateChanged: false,
      comment: '',
      dateError: false,
      commentError: false,
      showValidationHint: false,
    };
  }
  manageGetRescheduleTasks = () =>
    this.props.onClose(this.state.rescheduleSuccess, this.state.rescheduleFail, this.props.idTasks.length);
  validateDate = () => {
    const { dateChanged, dateSelected } = this.state;

    if (!dateSelected || Number.isNaN(dateSelected.getTime())) {
      return false;
    }

    if (!dateChanged) {
      return true;
    }

    return dateSelected >= new Date();
  };
  rescheduleTask = (e) => {
    e.preventDefault();
    const isDateValid = this.validateDate();
    const isCommentValid = this.state.comment.trim().length > 0;

    this.setState({
      dateError: !isDateValid,
      commentError: !isCommentValid,
      showValidationHint: !(isDateValid && isCommentValid),
    });

    if (isDateValid && isCommentValid) {
      const { dateSelected, comment } = this.state;
      const body = {
        taskInfo: {
          hour: dateSelected.getHours(),
          year: dateSelected.getFullYear(),
          month: dateSelected.getMonth(),
          day: dateSelected.getDate(),
          minute: dateSelected.getMinutes(),
          taskReschedule: {
            idTasks: this.props.idTasks,
            dateReschedule: dateSelected.getTime(),
            idUser: this.props.user.idUser,
            comment: comment.trim(),
          },
        },
      };

      const loadingConfig = { dispatch: this.props.dispatch };
      const onSuccess = this.manageGetRescheduleTasks;
      const onError = () => {
        this.setState({ rescheduleSuccess: false, rescheduleFail: true });
      };

      rescheduleTaskRequest(body, onSuccess, onError, loadingConfig);
    }
  };
  handleProgramDate = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      this.setState({
        dateSelected: null,
        dateChanged: true,
        dateError: true,
        showValidationHint: true,
      });
      return;
    }

    if (this.state.dateSelected !== date) {
      this.setState({
        dateSelected: date,
        dateChanged: true,
        dateError: false,
        showValidationHint: false,
      });
    }
  };
  handleCommentChange = (event) => {
    this.setState({
      comment: event.target.value,
      commentError: false,
      showValidationHint: false,
    });
  };
  render() {
    return (
      <Popup
        title={this.props.lan.rescheduleTask + ' - ' + this.state.taskDetails.taskNum}
        show
        closeButton
        onClose={this.props.onClose}
        buttonText={this.props.lan.save}
        requiredFields={this.props.lan.requiredFields}
        buttonOnClick={this.rescheduleTask}
        size={'auto'}
      >
        <Grid container spacing={3} sx={{ pt: 1 }}>
          <Grid size={12}>
            <Typography variant='caption' color='text.secondary'>
              {this.props.lan.typeTask}
            </Typography>
            <Typography variant='body2' sx={{ mt: 0.5 }}>
              {this.state.taskDetails.taskType || '-'}
            </Typography>
          </Grid>
          <Grid size={12}>
            <Typography variant='caption' color='text.secondary'>
              {this.props.lan.executionDate ?? this.props.lan.date}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker
                value={this.state.dateSelected}
                onChange={this.handleProgramDate}
                minDate={new Date()}
                minutesStep={30}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    sx: { mt: 1 },
                    error: this.state.dateError,
                    helperText: this.state.dateError
                      ? (this.props.lan.invalidDate ?? 'Invalid date')
                      : ' ',
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid size={12}>
            <Typography variant='caption' color='text.secondary'>
              {this.props.lan.commentTitle}
            </Typography>
            <TextField
              value={this.state.comment}
              onChange={this.handleCommentChange}
              fullWidth
              multiline
              minRows={3}
              sx={{ mt: 1 }}
              error={this.state.commentError}
              helperText={this.state.commentError ? `*${this.props.lan.requiredFields}` : ' '}
              slotProps={{
                endAdornment: this.state.commentError ? (
                  <InputAdornment position='end'>
                    <Box
                      component='img'
                      src={redAlertIcon}
                      alt=''
                      sx={{ width: 20, height: 20 }}
                    />
                  </InputAdornment>
                ) : undefined,
              }}
            />
          </Grid>
          {this.state.showValidationHint && this.props.lan.requiredFields && (
            <Grid size={12}>
              <Typography variant='caption' color='error'>
                *{this.props.lan.requiredFields}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Popup>
    );
  }
}
export default connect()(RescheduleTaskPopup);
//Original code:
/*import React, { Component } from 'react';
import Grid from '@mui/material/Grid2'
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import DatePickerFielder from '../../DatePickerFielder/DatePickerFielder';
import Popup from '../../Popup';
import '../MyOperation.css';
import { rescheduleTaskRequest } from '@core/api/task/task.service';
import { connect } from 'react-redux';

class RescheduleTaskPopup extends Component {
	constructor(props) {
		super(props);
		var taskNum = '';
		var taskType = '';
		var rescheduleSuccess = true;
		var rescheduleFail = false;
		var dateSelected = new Date();
		var tasksSize = this.props.tasks.length;
		for (var i = 0; i < tasksSize; i++) {
			var task = this.props.tasks[i];
			for (var j = 0; j < tasksSize; j++) {
				if (task.taskId === parseInt(this.props.idTasks[j])) {
					taskNum += ' [' + task.taskId + ']';
					taskType += ' [' + task.taskType + ']';
				}
			}
		}
		this.state = {
			taskDetails: { taskNum, taskType },
			dateSelected,
			minTime: new Date(),
			showErrorMessage: false,
			showErrorMessageText: '',
			showErrorMessageIcon: null,
			rescheduleSuccess: rescheduleSuccess,
			rescheduleFail: rescheduleFail,
			dateChanged: false,
		};
	}
	manageGetRescheduleTasks = () => this.props.onClose(this.state.rescheduleSuccess, this.state.rescheduleFail, this.props.idTasks.length);
	validateDate = () => {
		var currentDate = new Date();
		if (!this.state.dateChanged || this.state.dateSelected >= currentDate) {
			document.getElementById('executionDate-alert-icon').style.display = 'none';
			document.getElementById('executionDate-red-input').style.borderColor = '#ced4da';
			return true;
		}

		document.getElementById('executionDate-alert-icon').style.display = 'inline';
		document.getElementById('executionDate-red-input').style.borderColor = '#c70101';
		return false;
	};
	rescheduleTask = (e) => {
		e.preventDefault();
		var comment = document.getElementById('comment').value;
		var isValid = true;

		if (!this.validateDate()) {
			isValid = false;
		}

		if (comment === '') {
			isValid = false;
			document.getElementById('comment-alert-icon').style.display = 'inline';
			document.getElementById('comment').style.borderColor = '#c70101';
		} else {
			document.getElementById('comment-alert-icon').style.display = 'none';
			document.getElementById('comment').style.borderColor = '#ced4da';
		}

		if (isValid) {
			let dateSelected = this.state.dateSelected;
			const body = {
				taskInfo: {
					hour: dateSelected.getHours(),
					year: dateSelected.getFullYear(),
					month: dateSelected.getMonth(),
					day: dateSelected.getDate(),
					minute: dateSelected.getMinutes(),
					taskReschedule: {
						idTasks: this.props.idTasks,
						dateReschedule: dateSelected.getTime(),
						idUser: this.props.user.idUser,
						comment,
					},
				},
			}

			const loadingConfig = { dispatch: this.props.dispatch }
			const onSuccess = this.manageGetRescheduleTasks;
			const onError = () => {
				let state = this.state;
				state.rescheduleSuccess = false;
				state.rescheduleFail = true;
				this.setState(state);
			};

			rescheduleTaskRequest(body, onSuccess, onError, loadingConfig);
		} else {
			document.getElementById('register-form-hint').style.display = 'block';
		}
	};
	handleProgramDate = (date) => {
		var minTime = new Date();
		if (this.state.dateSelected !== date) {
			if (
				date.getDate() !== new Date().getDate() ||
				date.getMonth() !== new Date().getMonth() ||
				date.getFullYear() !== new Date().getFullYear()
			) {
				minTime = new Date().setHours(0, 0);
			}
			this.setState({
				dateSelected: date,
				minTime: minTime,
				dateChanged: true,
			});
		}
	};
	render() {
		return (
			<Popup
				title={this.props.lan.rescheduleTask + ' - ' + this.state.taskDetails.taskNum}
				show
				closeButton
				onClose={this.props.onClose}
				buttonText={this.props.lan.save}
				requiredFields={this.props.lan.requiredFields}
				buttonOnClick={this.rescheduleTask}
				size={'auto'}
			>
				<Grid container>
					<Grid size={12}>
<Grid container className='mt-1'>
  <Grid size={12} className='small-popup-label'>{this.props.lan.typeTask}</Grid>
  <Grid size={12} className='popup-label my-2 ml-2'>{this.state.taskDetails.taskType}</Grid>
</Grid>
<DatePickerFielder
  id='executionDate-red-input'
  selected={this.state.dateSelected}
  handleDate={this.handleProgramDate}
  minDate={new Date()}
  timeFormat='HH:mm'
  minTime={this.state.minTime}
  maxTime={new Date().setHours(23, 59)}
  dateFormat='dd/MM/yyyy h:mm aa'
  timeIntervals={30}
  classNamePicker='MyOperation-eschedule form-control mt-1 text-left'
  imgId='executionDate-alert-icon'
  classNameImg='CreateTask-dir-desc-fieldContainer-icon'
/>
<Grid container className='mt-3'>
  <Grid size={12} className='small-popup-label'>{this.props.lan.commentTitle}</Grid>
  <Grid size={12}>
    <div className='form-group col'>
      <textarea className='form-control' rows='3' cols='40' id='comment'></textarea>
      <img
        src={redAlertIcon}
        alt=''
        id='comment-alert-icon'
        className='field-alert-icon' />
    </div>
  </Grid>
</Grid>
</Grid>
</Grid>
</Popup>
);
}
}
export default connect()(RescheduleTaskPopup);
*/
